import FlightsCarsPackagesCarouselContainerMobile from '../../../../components/containers/FlightsCarsPackagesCarouselContainerMobile';
import deepmerge from '../../../utils/deepmerge';
import preloadCustomProps from '../../../utils/preloads/preloadFaresFlightsCarsPackagesGrid';

const cmpConfig = {
  name: 'flights-cars-packages-carousel--mobile',
  moduleId: 'em-cmp-lib-airmodules',
  containerConfig: {
    settings: {
      instance: FlightsCarsPackagesCarouselContainerMobile
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
